import RobotoFontStyle from "@fontsource/roboto";
import AuiThemeStyle from "./aui-theme.scss";

const style = document.createElement("style");
style.textContent = RobotoFontStyle + AuiThemeStyle;
document.head.appendChild(style);